export const loadCanvasQrCode = (qrImage, qrUrl, participant) => {
    if (!qrImage || !qrUrl || !participant) {
        console.error('Missing required parameters for QR code download');
        return;
    }
    const qrSize = 512;
    const labelHeight = 80;
    const canvas = document.createElement('canvas');
    canvas.width = qrSize;
    canvas.height = qrSize + labelHeight;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
        ctx.drawImage(img, 0, 0, qrSize, qrSize);
        // Busca o SUBJID do participante selecionado
        const subjId = participant.nickname || '';
        const uuidShort = qrUrl.split('/').pop().split('-')[0];
        const label = `${subjId} | ${uuidShort}`;
        ctx.font = 'bold 32px Arial';
        ctx.fillStyle = '#222';
        ctx.textAlign = 'center';
        ctx.fillText(label, qrSize / 2, qrSize + 56);
        const link = document.createElement('a');
        link.download = `qrcode_${subjId}_uuid_${uuidShort}.png`;
        link.href = canvas.toDataURL('image/png');
        link.click();
    };
    img.src = qrImage;
};